const defaultCity = {
	value: 'Top Destinations',
	urlDataKey: 'top-destinations'
};
const destinationTypeOptions = [
	{
		value: 'DOMESTIC',
		label: 'Domestic',
		infoText: 'Inside India',
		mobileLabel: 'Domestic',
		subLabel: 'Inside India',
		apiDataKey: 'Domestic',
		urlDataKey: 'dom'
	},
	{
		value: 'INTERNATIONAL',
		label: 'International',
		infoText: 'Outside India',
		mobileLabel: 'International',
		subLabel: 'Outside India',
		apiDataKey: 'International',
		urlDataKey: 'int'
	}
];
const eventTypeOptions = [
	{
		value: 'TEAM_OFFSITE',
		label: 'Team Offsite',
		apiDataKey: 'TEAM_OFFSITE',
		urlDataKey: 'team-offsite'
	},
	{
		value: 'ANNUAL_MEETING',
		label: 'Annual Meeting',
		apiDataKey: 'ANNUAL_MEETING',
		urlDataKey: 'annual-meeting'
	},
	{
		value: 'TOWNHALL',
		label: 'Townhall',
		apiDataKey: 'TOWNHALL',
		urlDataKey: 'townhall'
	},
	{
		value: 'BOARD_MEETINGS',
		label: 'Board Meeting',
		apiDataKey: 'BOARD_MEETINGS',
		urlDataKey: 'board-meetings'
	},
	{
		value: 'CONFERENCES',
		label: 'Conferences',
		apiDataKey: 'CONFERENCES',
		urlDataKey: 'conferences'
	},
	{
		value: 'PRODUCT_LAUNCH',
		label: 'Product Launch',
		apiDataKey: 'PRODUCT_LAUNCH',
		urlDataKey: 'product-launch'
	}
];

module.exports = {
	defaultCity,
	destinationTypeOptions,
	eventTypeOptions
};
